import apiRepository from 'Repositories/apiRepository';

export const AuthService = {
    async login(email, password) {
        try {
            const response = await apiRepository.post('/login', {email, password});
            return response.data;
        } catch (err) {
            throw err.response.data;
        }
    },

    async logout() {
        try {
            return await apiRepository.get('/logout');
        } catch (err) {
            throw err.response.data;
        }
    },

    async refreshToken(token, email) {
        try {
            const response = await apiRepository.post('/refresh', {token, email});
            return response.data;
        } catch (err) {
            throw err.response.data;
        }
    }
};
